import Forms, { IFormQuestion } from '@/models/Forms'

import { FormsService } from '@/service'
import { GroupState } from './groups'
import { reactive } from 'vue'

type FormData = {
  locationId: string
  groupId: string
  questions: IFormQuestion[]
}
export class FormsState {
  state = reactive({
    membershipQuestions: {} as Forms,
  })
  async upsertGroupFormData(formData: FormData): Promise<any> {
    this.state.membershipQuestions = await FormsService.create(formData)

    // here we are updating the group data with the form id becuase its updated in BE in the DB
    GroupState.state.groupData.settings.formId =
      this.state.membershipQuestions._id
    GroupState.state.updatedGroupData.settings.formId =
      this.state.membershipQuestions._id
    return this.state.membershipQuestions
  }
  async getGroupFormData(formId: string): Promise<any> {
    const forms = await FormsService.findById(formId)
    this.state.membershipQuestions = forms
    return forms
  }
}
export const FormState = new FormsState()
